export const themeConfig = {
  /** Base */
  direction: 'ltr',
  defaultMode: 'light',
  modeStorageKey: 'theme-mode',
  classesPrefix: 'me', // 'mestore',
  /** Typography */
  fontFamily: {
    primary: 'Public Sans Variable',
    secondary: 'Barlow',
  },
  /**
  Generate palette from:
  @see https://m2.material.io/inline-tools/color/
  Recommended token mapping:
    100 → lighter
    300 → light
    500 → main
    700 → dark
    900 → darker
  */
  /** Palette */
  palette: {
    primary: {
      lighter: '#FEB8D4',
      light: '#FF4F98',
      main: '#FF0080',
      dark: '#D70060',
      darker: '#9B0058',
      contrastText: '#FFFFFF',
    },
    secondary: {
      lighter: '#EFD6FF',
      light: '#C684FF',
      main: '#8E33FF',
      dark: '#5119B7',
      darker: '#27097A',
      contrastText: '#FFFFFF',
    },
    info: {
      lighter: '#CAFDF5',
      light: '#61F3F3',
      main: '#00B8D9',
      dark: '#006C9C',
      darker: '#003768',
      contrastText: '#FFFFFF',
    },
    success: {
      lighter: '#D3FCD2',
      light: '#77ED8B',
      main: '#22C55E',
      dark: '#118D57',
      darker: '#065E49',
      contrastText: '#FFFFFF',
    },
    warning: {
      lighter: '#FFF5CC',
      light: '#FFD666',
      main: '#FFAB00',
      dark: '#B76E00',
      darker: '#7A4100',
      contrastText: '#1C252E',
    },
    error: {
      lighter: '#FFCDD2',
      light: '#E57373',
      main: '#F44336',
      dark: '#D32F2F',
      darker: '#B71C1C',
      contrastText: '#FFFFFF',
    },
    grey: {
      50: '#F8FAFD',
      100: '#F3F5F8',
      200: '#EBEDF0',
      300: '#DDDFE2',
      400: '#C4CDD5',
      500: '#98A0A9',
      600: '#646F79',
      700: '#0C0C0C',
      800: '#050505',
      900: '#030303',
    },
    common: {
      black: '#000000',
      white: '#FFFFFF',
    },
  },
  /** Css variables */
  cssVariables: {
    cssVarPrefix: '',
    colorSchemeSelector: 'data-color-scheme',
  },
};
